import React from "react";
import { Link as LinkIcon, Heart, Crown, Sparkle } from "lucide-react";

const PILLARS = [
    {
        title: "Break Toxic Cycles",
        copy: "Naming the patterns we inherited so we can choose what we pass on.",
        icon: LinkIcon,
        size: "md:col-span-2",
    },
    {
        title: "Heal Deep Wounds",
        copy: "Tools, prayer, and tender truth for the wounds underneath.",
        icon: Heart,
    },
    {
        title: "Restore Your Identity",
        copy: "Remember the name God already gave you. Self-worth, rebuilt.",
        icon: Crown,
    },
    {
        title: "Walk in Purpose",
        copy: "Stop shrinking. Take up space in the rooms God called you to rise in.",
        icon: Sparkle,
        size: "md:col-span-2",
    },
];

export const Topics = () => {
    return (
        <section id="topics" data-testid="topics-section" className="relative py-24 md:py-36 bg-gradient-to-b from-lilac-50 to-[#F4ECF7]">
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
                    <div>
                        <div className="eyebrow text-gold-deep mb-4">The four pillars</div>
                        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-tight text-lilac-900 max-w-2xl">
                            Conversations the <em className="italic gold-text">cycle-breaker</em> needs.
                        </h2>
                    </div>
                    <p className="max-w-sm text-lilac-700 leading-relaxed">
                        Real conversations. Raw healing. Kingdom transformation — every episode lives
                        at the intersection of faith, feminine wholeness, and the practical work of becoming.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {PILLARS.map((t) => (
                        <div
                            key={t.title}
                            data-testid={`topic-${t.title.toLowerCase().replace(/\s+/g, "-")}`}
                            className={`group relative rounded-3xl border border-border bg-white p-7 overflow-hidden hover:shadow-[0_24px_64px_rgba(43,29,53,0.08)] transition-shadow ${
                                t.size || ""
                            }`}
                        >
                            <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-lilac-100/70 blur-2xl group-hover:bg-gold/10 transition-colors" />
                            <div className="relative flex items-start justify-between">
                                <t.icon className="w-6 h-6 text-gold-deep" strokeWidth={1.4} />
                                <span className="eyebrow text-lilac-700">Pillar</span>
                            </div>
                            <h3 className="relative font-display text-2xl md:text-3xl text-lilac-900 mt-12">
                                {t.title}
                            </h3>
                            <p className="relative mt-3 text-sm md:text-base text-lilac-700 max-w-sm leading-relaxed">
                                {t.copy}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
